import { create } from "zustand";

interface TimezoneState {
  timezone: string;
  getCurrentTimezone: () => string;
}

const useTimezoneStore = create<TimezoneState>()((set, get) => ({
  timezone: "America/Los_Angeles",
  getCurrentTimezone: () => get().timezone,
}));

export default useTimezoneStore;
